var uncurryThis = require('../internals/function-uncurry-this');

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/this-number-value.js
// module id = 387
// module chunks = 0